module.exports = {
  globalScope: 'p5',
  globalVars: {
    
    // Map methods
    pushMatrix: 'push',
    popMatrix: 'pop',
    size: 'createCanvas',
    println: 'print',
    PVector: 'Vector',

    // Fix literal methods
    int$: 'int',
    float$: 'float',
    byte$: 'byte',
    char$: 'char',
    boolean$: 'boolean',

    // Methods
    alpha: true,
    blue: true,
    brightness: true,
    color: true,
    green: true,
    hue: true,
    lerpColor: true,
    lightness: true,
    red: true,
    saturation: true,
    background: true,
    clear: true,
    colorMode: true,
    fill: true,
    noFill: true,
    noStroke: true,
    stroke: true,
    arc: true,
    ellipse: true,
    line: true,
    point: true,
    quad: true,
    rect: true,
    triangle: true,
    ellipseMode: true,
    noSmooth: true,
    rectMode: true,
    smooth: true,
    strokeCap: true,
    strokeJoin: true,
    strokeWeight: true,
    bezier: true,
    bezierDetail: true,
    bezierPoint: true,
    bezierTangent: true,
    curve: true,
    curveDetail: true,
    curveTightness: true,
    curvePoint: true,
    curveTangent: true,
    beginContour: true,
    beginShape: true,
    bezierVertex: true,
    curveVertex: true,
    endContour: true,
    endShape: true,
    quadraticVertex: true,
    vertex: true,
    loadModel: true,
    model: true,
    plane: true,
    box: true,
    sphere: true,
    cylinder: true,
    cone: true,
    ellipsoid: true,
    torus: true,
    preload: true,
    setup: true,
    draw: true,
    remove: true,
    noLoop: true,
    loop: true,
    redraw: true,
    print: true,
    cursor: true,
    frameRate: true,
    noCursor: true,
    windowResized: true,
    fullscreen: true,
    pixelDensity: true,
    displayDensity: true,
    getURL: true,
    getURLPath: true,
    getURLParams: true,
    resizeCanvas: true,
    noCanvas: true,
    createGraphics: true,
    blendMode: true,
    setAttributes: true,
    applyMatrix: true,
    resetMatrix: true,
    rotate: true,
    rotateX: true,
    rotateY: true,
    rotateZ: true,
    scale: true,
    shearX: true,
    shearY: true,
    translate: true,
    createStringDict: true,
    createNumberDict: true,
    append: true,
    arrayCopy: true,
    concat: true,
    reverse: true,
    shorten: true,
    shuffle: true,
    sort: true,
    splice: true,
    subset: true,
    float: true,
    int: true,
    str: true,
    boolean: true,
    byte: true,
    char: true,
    unchar: true,
    hex: true,
    unhex: true,
    join: true,
    match: true,
    matchAll: true,
    nf: true,
    nfc: true,
    nfp: true,
    nfs: true,
    split: true,
    splitTokens: true,
    trim: true,
    setMoveThreshold: true,
    setShakeThreshold: true,
    deviceMoved: true,
    deviceTurned: true,
    deviceShaken: true,
    keyPressed: true,
    keyReleased: true,
    keyTyped: true,
    keyIsDown: true,
    mouseMoved: true,
    mouseDragged: true,
    mousePressed: true,
    mouseReleased: true,
    mouseClicked: true,
    doubleClicked: true,
    mouseWheel: true,
    touchStarted: true,
    touchMoved: true,
    touchEnded: true,
    createImage: true,
    saveCanvas: true,
    saveFrames: true,
    loadImage: true,
    image: true,
    tint: true,
    noTint: true,
    imageMode: true,
    blend: true,
    copy: true,
    filter: true,
    get: true,
    loadPixels: true,
    set: true,
    updatePixels: true,
    loadJSON: true,
    loadStrings: true,
    loadTable: true,
    loadXML: true,
    loadBytes: true,
    httpGet: true,
    httpPost: true,
    httpDo: true,
    createWriter: true,
    save: true,
    saveJSON: true,
    saveStrings: true,
    saveTable: true,
    day: true,
    hour: true,
    minute: true,
    millis: true,
    month: true,
    second: true,
    year: true,
    createVector: true,
    abs: true,
    ceil: true,
    constrain: true,
    dist: true,
    exp: true,
    floor: true,
    lerp: true,
    log: true,
    mag: true,
    map: true,
    max: true,
    min: true,
    norm: true,
    pow: true,
    round: true,
    sq: true,
    sqrt: true,
    noise: true,
    noiseDetail: true,
    noiseSeed: true,
    randomSeed: true,
    random: true,
    randomGaussian: true,
    acos: true,
    asin: true,
    atan: true,
    atan2: true,
    cos: true,
    sin: true,
    tan: true,
    degrees: true,
    radians: true,
    angleMode: true,
    textAlign: true,
    textLeading: true,
    textSize: true,
    textStyle: true,
    textWidth: true,
    textAscent: true,
    textDescent: true,
    loadFont: true,
    text: true,
    textFont: true,
    camera: true,
    perspective: true,
    ortho: true,
    orbitControl: true,
    ambientLight: true,
    directionalLight: true,
    pointLight: true,
    loadShader: true,
    createShader: true,
    shader: true,
    normalMaterial: true,
    texture: true,
    ambientMaterial: true,
    specularMaterial: true,

    // Classes
    Graphics: true,
    Vector3: true,

    // Constants
    P2D: true,
    WEBGL: true,
    ARROW: true,
    CROSS: true,
    HAND: true,
    MOVE: true,
    TEXT: true,
    WAIT: true,
    HALF_PI: true,
    PI: true,
    QUARTER_PI: true,
    TAU: true,
    TWO_PI: true,
    DEGREES: true,
    RADIANS: true,
    DEG_TO_RAD: true,
    RAD_TO_DEG: true,
    CORNER: true,
    CORNERS: true,
    RADIUS: true,
    RIGHT: true,
    LEFT: true,
    CENTER: true,
    TOP: true,
    BOTTOM: true,
    BASELINE: true,
    POINTS: true,
    LINES: true,
    LINE_STRIP: true,
    LINE_LOOP: true,
    TRIANGLES: true,
    TRIANGLE_FAN: true,
    TRIANGLE_STRIP: true,
    QUADS: true,
    QUAD_STRIP: true,
    CLOSE: true,
    OPEN: true,
    CHORD: true,
    PIE: true,
    PROJECT: true,
    SQUARE: true,
    ROUND: true,
    BEVEL: true,
    MITER: true,
    RGB: true,
    HSB: true,
    HSL: true,
    AUTO: true,
    ALT: true,
    BACKSPACE: true,
    CONTROL: true,
    DELETE: true,
    DOWN_ARROW: true,
    ENTER: true,
    ESCAPE: true,
    LEFT_ARROW: true,
    OPTION: true,
    RETURN: true,
    RIGHT_ARROW: true,
    SHIFT: true,
    TAB: true,
    UP_ARROW: true,
    BLEND: true,
    ADD: true,
    DARKEST: true,
    LIGHTEST: true,
    DIFFERENCE: true,
    EXCLUSION: true,
    MULTIPLY: true,
    SCREEN: true,
    REPLACE: true,
    OVERLAY: true,
    HARD_LIGHT: true,
    SOFT_LIGHT: true,
    DODGE: true,
    BURN: true,
    THRESHOLD: true,
    GRAY: true,
    OPAQUE: true,
    INVERT: true,
    POSTERIZE: true,
    DILATE: true,
    ERODE: true,
    BLUR: true,
    NORMAL: true,
    ITALIC: true,
    BOLD: true,
    LINEAR: true,
    QUADRATIC: true,
    BEZIER: true,
    CURVE: true,
    STROKE: true,
    FILL: true,
    TEXTURE: true,
    IMMEDIATE: true,
    NEAREST: true,
    REPEAT: true,
    CLAMP: true,
    MIRROR: true,
    LANDSCAPE: true,
    PORTRAIT: true,
    GRID: true,
    AXES: true, 

    // Variables
    frameCount: true,
    focused: true,
    Color: true,
    displayWidth: true,
    displayHeight: true,
    windowWidth: true,
    windowHeight: true,
    width: true,
    height: true,
    deviceOrientation: true,
    accelerationX: true,
    accelerationY: true,
    accelerationZ: true,
    pAccelerationX: true,
    pAccelerationY: true,
    pAccelerationZ: true,
    rotationX: true,
    rotationY: true,
    rotationZ: true,
    pRotationX: true,
    pRotationY: true,
    pRotationZ: true,
    turnAxis: true,
    keyIsPressed: true,
    key: true,
    keyCode: true,
    mouseX: true,
    mouseY: true,
    pmouseX: true,
    pmouseY: true,
    winMouseX: true,
    winMouseY: true,
    pwinMouseX: true,
    pwinMouseY: true,
    mouseButton: true,
    mouseIsPressed: true,
    touches: true,
    pixels: true,
  },
};
